/**
 * @descripton Displays the results of the personnel sync operation
 */

import React from 'react';
import Stack from '@mui/material/Stack';

import ErrorBoundary from '@seccon/shared/ui/components/ErrorBoundary';

import CountList from './CountList';
import UnmappedColumns from './UnmappedColumns';
import FailedPartialSyncs from './FailedPartialSyncs';
import SuccessfulSyncs from './SuccessfulSyncs';

const styles = {
  resultsContainer: {
    width: '100%'
  }
};

const SyncResults = () => (
  <Stack spacing={3} sx={styles.resultsContainer}>
    <ErrorBoundary>
      <CountList />
    </ErrorBoundary>
    <ErrorBoundary>
      <UnmappedColumns />
    </ErrorBoundary>
    <ErrorBoundary>
      <SuccessfulSyncs />
    </ErrorBoundary>
    <ErrorBoundary>
      <FailedPartialSyncs />
    </ErrorBoundary>
  </Stack>
);

export default SyncResults;
